export function CapitalizeDirective() {
    return {
        require: 'ngModel',
        link: link
    };

    function link(scope, element, attrs, modelCtrl) {
        var capitalize = function (inputValue) {
            if (inputValue == undefined) inputValue = '';
            var capitalized = inputValue.toUpperCase();
            if (capitalized !== inputValue) {
                modelCtrl.$setViewValue(capitalized);
                modelCtrl.$render();
            }
            return capitalized;
        };
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]); // capitalize initial value
    }
}


// WEBPACK FOOTER //
// ./client/components/util/text-uppercase.js